import { linkStatusPieChartColor } from "../../../reusableComponents/constants";

export const failedTransactionSchema = (
  chartDataPoints,
  chartMetrics,
  tableDataPoints,
  tableDataMetrics
) => {
  function compare(a, b) {
    return (
      parseFloat(b.statusReasonCountPercent) -
      parseFloat(a.statusReasonCountPercent)
    );
  }
  if (chartDataPoints) {
    chartDataPoints.sort(compare);
  }


  const sumOfStatusGmvLocale = tableDataMetrics?.gmvSumLocale || 0;
  const sumOfStatusCountLocale = tableDataMetrics?.totalCountLocale || 0;
  let tableData = [];
  if (tableDataMetrics?.gmvSum >= 1) {
    tableData = [
      ...tableDataPoints?.map((item) => ({
        reasonCode: item?.reasonCode,
        reason: item?.statusReason,
        value: item?.gmvLocaleFull,
        // value: item?.gmvLocale,
        value_sort: item?.gmv,
        count: item?.statusReasonCountLocale,
        count_sort: item?.reasonCodeCount,
      })),
    ];
  }

  if (chartDataPoints?.length > 5) {
    let percentageSum = 0;
    for (let i = 5; i < chartDataPoints?.length; i++) {
      percentageSum =
        parseFloat(percentageSum) +
        parseFloat(chartDataPoints[i]?.statusReasonCountPercent);
    }
    chartDataPoints = chartDataPoints?.slice(0, 5);
    chartDataPoints.push({
      statusReasonCountPercent: percentageSum.toFixed(2),
      statusReason: "Others",
    });
  }

  const chartOptions = {
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (context) {
            let label = context?.label;
            return `${label.substring(0, 60)}${label?.length > 60 ? "..." : ""
              } : ${context.parsed} %`;
          },
        },
      },
      legend: {
        padding: 20,
        position: "right",
        labels: {
          usePointStyle: true,
          generateLabels: function (chart) {
            const data = chart?.data;
            if (data?.labels?.length && data?.datasets?.length) {
              return data?.labels.map(function (label, i) {
                const value = data?.datasets[0].data[i];
                return {
                  text: `${label.substring(0, 30)}${label?.length > 30 ? "..." : ""
                    } : ${value} %`,
                  fillStyle: data?.datasets[0].backgroundColor[i],
                  hidden:
                    isNaN(data?.datasets[0].data[i]) ||
                    chart.getDatasetMeta(0).data[i].hidden,
                  index: i,
                };
              });
            }
            return [];
          },
        },
      },
      datalabels: {
        formatter: function (value, context) {
          return context.chart.data.labels[context.dataIndex];
        },
      },
    },
  };

  const chartData = {
    labels: chartDataPoints?.map((item) => item?.statusReason),
    datasets: [
      {
        label: "Payment Category Split by Transaction Count",
        data: chartDataPoints?.map((item) => item?.statusReasonCountPercent),
        backgroundColor: linkStatusPieChartColor,
        borderColor: "#fff",
        borderWidth: 1,
        hoverBackgroundColor: linkStatusPieChartColor,
      },
    ],
  };
  return {
    chartDataPoints,
    tableDataPoints,
    chartData,
    chartOptions,
    tableData,
  };
};
